import { FormikProps } from 'formik'
import { Checkbox, FormControl, Text } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'
import { IssueFormValues } from './types'

interface ConsentCheckboxProps {
  formikProps: FormikProps<IssueFormValues>
}

/** Checkbox that captures the consumer's consent for Veho to contact them about their issue. */
export default function ConsentCheckbox({ formikProps }: ConsentCheckboxProps) {
  const { values, errors, touched, setFieldValue } = formikProps

  return (
    <FormControl isInvalid={!!(errors.consentChecked && touched.consentChecked)} backgroundColor={'transparent'} mb={4}>
      <Checkbox
        isChecked={values.consentChecked}
        onChange={isSelected => setFieldValue('consentChecked', isSelected)}
        value="consentChecked"
        accessibilityLabel="consent to contact"
        borderRadius={4}
        borderWidth={2}
        borderColor={colors.brand.softBlack}
        backgroundColor={colors.brand.transparent}
        _icon={{
          size: 3,
          color: colors.brand.softBlack,
        }}
        _checked={{
          borderWidth: 2,
          borderColor: colors.brand.softBlack,
          backgroundColor: colors.brand.transparent,
        }}
        display="flex"
        alignItems="center"
      >
        <Text fontSize={14} fontWeight={400} lineHeight="125%" color={colors.brand.softBlack}>
          You can use the contact info above to contact me about my order via SMS or email.
        </Text>
      </Checkbox>
      {errors.consentChecked && touched.consentChecked && (
        <FormControl.ErrorMessage backgroundColor={'transparent'}>{errors.consentChecked}</FormControl.ErrorMessage>
      )}
    </FormControl>
  )
}
